import * as React from 'react'
import * as css from './HeroChecklist.module.css'
import HexPatternSection from 'components/common/HexPatternSection'
import SanityBlock from 'components/common/SanityBlock'

const HeroChecklist = ({ _rawContent, _rawChecklistContent }) => {
  return (
    <section className="overflow-hidden">
      <HexPatternSection>
        <div className="ctnr padding-x grid md:grid-cols-2 gap-y-8 gap-x-12">
          <header className="[&_h2]:h1">
            <SanityBlock body={_rawContent} />
          </header>

          <div>
            <SanityBlock
              body={_rawChecklistContent}
              components={{
                list: ({ type, children }) => {
                  switch(type) {
                    case 'bullet': return <ul className={css.bullet}>{children}</ul>
                    default: return null
                  }
                }
              }}
            />
          </div>
        </div>
      </HexPatternSection>
    </section>
  )
}

export default HeroChecklist
